module.exports = __webpack_public_path__ + "img/20-building-alliances.5b5e84c9.jpg";